import type { CachedDataset, DatasetKey, Profile } from '../types'

const DATA_PREFIX = 'suite.v8.dataset.'
const PROFILE_KEY = 'suite.v8.profile'

export function saveDataset(key: DatasetKey, records: Record<string, unknown>[]) {
  const payload: CachedDataset = {
    savedAt: new Date().toISOString(),
    records,
  }
  localStorage.setItem(`${DATA_PREFIX}${key}`, JSON.stringify(payload))
}

export function readDataset(key: DatasetKey): CachedDataset | null {
  try {
    const raw = localStorage.getItem(`${DATA_PREFIX}${key}`)
    return raw ? (JSON.parse(raw) as CachedDataset) : null
  } catch {
    return null
  }
}

export function saveProfile(profile: Profile) {
  localStorage.setItem(PROFILE_KEY, JSON.stringify(profile))
}

export function readProfile(): Profile | null {
  try {
    const raw = localStorage.getItem(PROFILE_KEY)
    return raw ? (JSON.parse(raw) as Profile) : null
  } catch {
    return null
  }
}

export function clearLocalSessionData() {
  localStorage.removeItem(PROFILE_KEY)
}
